module.exports = {"lang":"Selected language","langs":{"en":"English","sl":"Slovenian","de":"German"}}


//////////////////
// WEBPACK FOOTER
// ./static/locales/en/language.json
// module id = 552
// module chunks = 114276838955818